import React, { PropTypes } from 'react';
import ContentBuilder from '../../Page';

class Flipper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flipped: false
    };
    this.toggleFlipped = this.toggleFlipped.bind(this);
    // this.onFormChange = this.onFormChange.bind(this);
  }

  toggleFlipped() {
    this.setState(prevState => ({
      flipped: !prevState.flipped
    }));
  }

  render() {
    const { value: { type = 'default', content:{ front = [], back = [] }, style } } = this.props;
    const { flipped } = this.state;
    const styles = require('./styles.scss');
    return (
      <div style={style.wrapper} className={styles[`wrapper_${type}`]} onClick={this.toggleFlipped}>
        <div className={flipped ? styles.flipContainer_flipped : styles.flipContainer}>
          <div className={styles.flipper}>
            <div style={style.card_front} className={styles.card_front}>
              <div className={styles.content_front}>
                <ContentBuilder data={front} />
              </div>
            </div>
            <div style={style.card_back} className={styles.card_back}>
              <div className={styles.content_back}>
                <ContentBuilder data={back} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


Flipper.propTypes = {
  value: PropTypes.shape({
    type: PropTypes.string,
    fram: PropTypes.arrayOf(
      PropTypes.string,
    ),
    bak: PropTypes.arrayOf(
      PropTypes.string
    )
  })
};

export default Flipper;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Flipper/Flipper.js
 **/